import React from 'react';
import styles from './Selectable.module.scss';
import cx from 'classnames';

interface Proptype {
  selected?: boolean;
  disabled?: boolean;
  theme?: 'light' | 'darker' | 'border';
  className?: string;
  onClick?: () => void;
}

const Selectable: React.FC<Proptype> = ({
  selected,
  disabled,
  theme,
  className,
  children,
  onClick,
}) => {
  const classNames = cx(styles.selectable, className, {
    [styles.selectable_selected]: selected,
    [styles.selectable_active]: !disabled,
    [styles[`selectable_theme-${theme}`]]: theme,
  });

  return (
    <div className={classNames} onClick={onClick}>
      {children}
    </div>
  );
};

export { Selectable };
